<template>
	<div>
		<Header :sel='2' @changePhone="changePhone" />
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<div class="banner">

			</div>
			<!--banner-->

			<!--neirong-->
			<div class="bread_bg">
				<div class="bread"> <a href="/">首页</a> - <a href="javascript:void(0)" @click="goMore('/solutionList')">解决方案</a>- <a
						href="javascript:void(0)">{{categoryName? categoryName : '全部'}} </a></div>
			</div>
			<div class="neirong">

				<ul class="fangan_list">

					<li v-for="(item,index) in jiejuefanganList">
						<template v-if="index % 2 === 0">
							<div class="fangan_txt">
								<div class="fangan_t" >
								<a href="javascript:void(0)"@click="goDetail2(item.categoryCode,item.categoryName)">{{ item.categoryName }}</a>
								</div>
								<div class="fangan_c" v-html="item.introduction"></div>
								<ul class="fangan_erji">
									<li v-for="items in item.childList"><a href="javascript:void(0)"
											@click="goDetail(items.categoryCode)">{{ items.categoryName }}</a></li>
								</ul>
							</div>
							<div class="fangan_pic"><img :src="item.image" /></div>
						</template>

						<template v-else>
							<div class="fangan_pic"><img :src="item.image" /></div>
							<div class="fangan_txt">
								<div class="fangan_t" >
								<a href="javascript:void(0)"@click="goDetail2(item.categoryCode,item.categoryName)">{{ item.categoryName }}</a>
								</div>
								<div class="fangan_c" v-html="item.introduction"></div>
								<ul class="fangan_erji">
									<li v-for="items in item.childList"><a href="javascript:void(0)"
											@click="goDetail(items.categoryCode)">{{ items.categoryName }}</a></li>
								</ul>
							</div>
						</template>
					</li>

				</ul>

				<div class="fangan_bq">案例推荐</div>
				<ul class="anli_tuijian">
					<li v-for="(item,index) in caseList" :key="index"><a href="javascript:void(0)"
							@click="getCaseDetail(item.id)">{{item.clientName}} | {{item.caseName}}</a></li>
				</ul>

			</div>
			<!--neirong-->
			<!--main-->
			<Footer />
		</div>


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		getSolutionList,
		getCaseList
	} from '@/api/reqFetch.js'
	export default {
		components: {
			Footer,
			Header,
		},
		name: '',
		layout: '',

		data() {
			return {
				id: '',
				categoryName:'',
				list: [],
				pagenum: 1,
				indexs: [],
				totalPage: 0,
				jiejuefanganList: [],
				title: '',
				showPhone: false,
				caseList:[]
			}
		},

		created() {
			this.id = this.$route.query.id
			this.categoryName = this.$route.query.name
			this.getData()
			this.getCaseList()
		},
		// mounted() {
		// 	this.id=this.$route.query.id

		// },

		methods: {
			getCaseDetail(id) {
				this.$router.push({
					path: '/caseDetail',
					query: {
						id: id
					}
				})
			},
			getCaseList() {
				getCaseList({
					pageNumber: 1,
					pageSize: 10,
					categoryCode: this.id,
					categoryName: ''
				}).then(res => {
					this.caseList = res.data.list

				});
			},

			changePhone(val) {
				this.showPhone = val
			},


			getData() {
				getSolutionList({
					// categoryCode: '2000',
					categoryCode: this.id ? this.id : '2000'
				}).then(res => {
					this.jiejuefanganList = res.data

				});
			},
			goDetail(id) {
				this.$router.push({
					path: '/solutionDetail',
					query: {
						id: id
					}
				})
			},
			goDetail2(id,name) {
				this.$router.push({
					path: '/solutionList',
					query: {
						id: id,
						name: name
					}
				}).then(() => {
					// 跳转成功后刷新页面
					window.location.reload();
				});


			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},
			goMore(url) {
				this.$router.replace(url).then(() => {
					// 跳转成功后刷新页面
					window.location.reload();
				});
			},
			
		}
	}
</script>

<style scoped>
	.banner {
		background-image: url('../../assets/images/banner_02.png');
	}
</style>